@import url("https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/css/bootstrap.min.css"); 
/* @import url("../../../node_modules/bootstrap/dist/css/bootstrap.min.css");  */

:host {
 display: block;
}


/*custom */

a , a:visited {
 color: #b71d1d;
 font-size: 16px;
 text-decoration: none;
}

  /* @media (max-width: 767.98px) {
    .card-img-top {
      height: 100%;
      
      }
    } */

.content-padding {
  padding-bottom:20px;
  padding-top:20px
}
::-webkit-scrollbar {
  width: 2px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #D3D3D3; 
}


.sect {
  position: relative;
  max-width: 800px;
  margin: 0 auto;
}

.sect img {vertical-align: middle;}

.sect .content {
  position: absolute;
  bottom: 0;
  background: rgb(0, 0, 0); /* Fallback color */
  background: rgba(0, 0, 0, 0.5); /* Black background with 0.5 opacity */
  color: #f1f1f1;
  width: 100%;
  padding:10px;
  
}

.card {
  background-color: transparent;
}
.top-container {
  display: grid;
            /* grid-template-columns: repeat(12,1fr); */
            grid-auto-flow: column;
            gap: 5px;

}

.top-container>div {
  /* background-color: rgba(255, 255, 255, 0.8);
  text-align: center;
  padding: 20px 0;
  font-size: 30px; */
}
.grid-item img {
         
  width:100%;
  height: auto;
  
}

@media only screen and (max-width: 600px) {
  .top-container {
    grid-auto-flow: row;

  }

}